/* ============================================================
   LU - Cupon en el carrito (29-sep-2026, pedido de Sebas)
   "Un boton en el carrito de redimir cupon, el de $10.000... solo ahi, fijo,
   que no ocupe tanto espacio y que al redimir se vea aplicado... que no
   ralentice nada... se mantienen todos los contadores".
   Pinta la tira [data-lu-cup] del cajon (markup en snippets/cart-drawer.liquid)
   y atiende su boton.
   ARCHIVO PROPIO A PROPOSITO. Lo carga layout/theme.liquid al final del body
   con async, junto a component-lu-cup.css, que entra con media="print" y que
   pinta() activa la primera vez que la tira existe. Ninguno de los dos
   bloquea el pintado, y los archivos que SI estan en el camino critico
   (cart-drawer.js y component-lu-cart-drawer.css) quedaron identicos byte a
   byte. Quedan en cache desde la primera pagina. Con el interruptor apagado
   no se piden.
   Mientras la hoja no este activa la tira no se ve (trae display:none en
   linea y la hoja lo levanta): jamas aparece a medio vestir.
   La tira tiene 4 caras (atributo data-modo; el aspecto es CSS). Desde el
   3-oct (Sebas: «una pregunta en negrita notable: ¿QUIERES MAS DESCUENTO?
   SI / OBVIO; toca cualquiera y le aparece aplicado»):
     q    cupon sin redimir (nunca lo tuvo)           pregunta + botones SI / OBVIO
     r    se le vencio y queda la ultima de 10 min    «NO COMPRASTE RAPIDO Y PERDISTE LOS $10.000» + los mismos botones
     ok   cupon vigente (regalo o ultima oportunidad) titulo grande + linea pequeña + «Compra rapido antes de:» + reloj
     ok2  cupon de la 2a compra vigente               igual que ok, con sus propios textos (data-ok2)
   Los textos viajan en data-q / data-r / data-ok / data-ok2 del markup (si
   ok2 no trae el suyo, usa el de ok). Los dos botones hacen lo mismo.
   Sin cara (todo vencido, o ya compro y no hay cupon) queda oculta.
   QUIEN DECIDE es el cerebro de cupones (window.luCoupon, snippet
   lu-exit-seed): aqui no hay ni una regla de cupones nueva, solo se lee y se
   pinta. El boton llama a grantQuedate(true) o grantRescue(true) (true = aqui
   no se recarga la pagina: la huella va despues del cupon), que escriben el
   atributo _lu_cupon en el carrito (descuento automatico de la Function), y
   avisa con el evento lu:cupon-cambio: el cajon actualiza fila, total, ahorro
   y banner EN EL SITIO, sin recargar la pagina.
   Quien la llama: reveal() del cajon, en cada render y cada segundo mientras
   haya cupon vigente y el cajon este abierto; y este archivo una vez al
   llegar (por si el cajon se pinto antes).
   COSTO: con el carrito vacio la tira no existe y pinta() sale en la primera
   linea. El segundo a segundo del reloj solo cambia un texto (nodeValue): no
   lee medidas ni despierta a los observadores del cajon.
   ============================================================ */
(function () {
  if (window.luCupPinta) return;

  function estado() {
    try { return (window.luCoupon && window.luCoupon.state()) || null; } catch (e) { return null; }
  }
  function quedate() {
    try { return (window.luCoupon && window.luCoupon.quedate) ? window.luCoupon.quedate() : null; } catch (e) { return null; }
  }
  /* la compra hecha solo la ve el servidor (luTareas la publica) */
  function yaCompro() {
    try { return !!(window.luTareas && window.luTareas.estado && window.luTareas.estado().compra); } catch (e) { return false; }
  }
  function reloj(ms) {
    if (ms < 0) ms = 0;
    var s = Math.floor(ms / 1000);
    var h = Math.floor(s / 3600); s -= h * 3600;
    var m = Math.floor(s / 60); s -= m * 60;
    function p(n) { return (n < 10 ? '0' : '') + n; }
    return (h ? h + ':' + p(m) : p(m)) + ':' + p(s);
  }
  /* Cambia el texto por nodeValue, no por textContent: asi el reloj NO despierta
     a los MutationObserver del cajon cada segundo. */
  function pon(el, t) {
    if (!el || t == null) return;
    var n = el.firstChild;
    if (n && n.nodeType === 3 && !n.nextSibling) { if (n.nodeValue !== t) n.nodeValue = t; }
    else if (el.textContent !== t) el.textContent = t;
  }

  /* La hoja de la tira ya se bajo (media="print"); se activa la primera vez que
     la tira existe. Con el carrito vacio nunca se activa: cero recalculo. */
  var hoja = 0;
  function pinta(st) {
    var box = document.querySelector('cart-drawer [data-lu-cup]');
    if (!box) return;
    if (!hoja) {
      var l = document.getElementById('lu-cup-css');
      if (l) { if (l.media !== 'all') l.media = 'all'; hoja = 1; }
    }
    if (st === undefined) st = estado();
    var q = quedate(), modo = '';
    if (st && st.cod) modo = st.kind === 'exit' ? 'ok2' : 'ok';
    else if (q && !yaCompro()) modo = !q.granted ? 'q' : (q.rescueAvailable ? 'r' : '');
    if (!modo) { if (!box.hidden) box.hidden = true; return; }
    var on = modo === 'ok' || modo === 'ok2';
    var cta = box.querySelector('[data-lu-cup-cta]');
    if (box.getAttribute('data-modo') !== modo) {
      box.setAttribute('data-modo', modo);
      /* 3-oct (Sebas): cara q/r = pregunta + dos botones (SI / OBVIO); cara ok/ok2 = titulo grande + linea pequeña +
         linea de abajo con el reloj. Cada texto sale de su data-* (ok2 tiene los suyos: cupon de la 2a compra). */
      var t1 = box.querySelector('[data-lu-cup-t1]'), t2 = box.querySelector('[data-lu-cup-t2]'), t3 = box.querySelector('[data-lu-cup-t3]');
      var acts = box.querySelector('[data-lu-cup-acts]'), foot = box.querySelector('[data-lu-cup-foot]');
      var cara = modo === 'ok2' ? 'ok2' : (on ? 'ok' : modo);
      var tx = function (el) { if (!el) return ''; var v = el.getAttribute('data-' + cara); if (v == null && cara === 'ok2') v = el.getAttribute('data-ok'); return v || ''; };
      if (t1) pon(t1, tx(t1));
      if (t2) { var v2 = tx(t2); pon(t2, v2); t2.hidden = !v2; }
      if (t3) pon(t3, tx(t3));
      if (acts) acts.hidden = on;
      if (foot) foot.hidden = !on;
      var btns = box.querySelectorAll('[data-lu-cup-go]');
      for (var k = 0; k < btns.length; k++) { if (on) btns[k].setAttribute('aria-disabled', 'true'); else btns[k].removeAttribute('aria-disabled'); }
      box.__luCupFit = 0;
    }
    if (on && cta) pon(cta, '\u23F3 ' + reloj(st.exp - Date.now()));
    if (box.hidden) box.hidden = false;
    /* Medir cuesta (obliga al navegador a calcular el layout): se mide UNA vez
       por cara y solo con el cajon ABIERTO. Al cargar la pagina y en cada
       segundo del reloj aqui no se lee ni una medida. */
    if (!box.__luCupFit) {
      var d = box.closest('cart-drawer');
      if (d && d.classList.contains('active')) box.__luCupFit = cabe(box) ? 1 : 0;
    }
  }

  /* Los tres renglones SIEMPRE completos: si el texto no cabe en su columna
     (celulares de 320 px), se achica solo la letra de ese renglon, en
     proporcion. Nunca agranda: el tope lo pone el CSS. Primero se escribe,
     despues se lee todo junto y al final se escribe: UN solo calculo de layout.
     Devuelve false si todavia no habia nada que medir (la hoja de estilos no
     ha llegado y la tira mide 0): pinta() lo vuelve a intentar. */
  var ancho = 0;
  /* 3-oct: los textos ya se parten en renglones (white-space normal); no hay nada que achicar. Se conserva la funcion
     (la llama pinta) solo para saber si la tira ya tiene medidas. */
  function cabe(box) {
    var t = box.querySelector('[data-lu-cup-t1]');
    ancho = window.innerWidth;
    return !!(t && t.clientWidth);
  }
  /* celular girado con el cajon abierto: cambia el ancho, se vuelve a medir */
  window.addEventListener('resize', function () {
    if (!ancho || window.innerWidth === ancho) return;
    var box = document.querySelector('cart-drawer [data-lu-cup]');
    if (box) { box.__luCupFit = 0; pinta(); }
  }, { passive: true });

  /* Festejo de UNA pasada al redimir: la tira salta, 14 papelitos de colores, el
     total y la fila del cupon se encienden un instante y el celular vibra
     (Android). Nada de esto mueve el layout (transform, opacity, un color y un
     fondo); se limpia solo a los 1,1 s. */
  function festeja(btn) {
    var box = btn.closest('[data-lu-cup]');
    if (!box) return;
    var otros = document.querySelectorAll('cart-drawer .lu-tot__row--pay, cart-drawer [data-lu-brk]');
    var i;
    box.classList.add('is-just');
    for (i = 0; i < otros.length; i++) otros[i].classList.add('is-just');
    var quieto = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    if (!quieto) {
      var fx = document.createElement('span');
      fx.className = 'lu-cup__fx';
      fx.setAttribute('aria-hidden', 'true');
      var col = ['#e60023', '#f4d268', '#1a7f3c', '#0b6bb8'], h = '';
      for (i = 0; i < 14; i++) h += '<i style="--a:' + Math.round(i * 25.7) + 'deg;--d:' + (34 + (i % 4) * 13) + 'px;--c:' + col[i % 4] + '"></i>';
      fx.innerHTML = h;
      (box.querySelector('.lu-cup__in') || box).appendChild(fx);
    }
    try { if (navigator.vibrate) navigator.vibrate(35); } catch (e) {}
    setTimeout(function () {
      box.classList.remove('is-just');
      for (var k = 0; k < otros.length; k++) otros[k].classList.remove('is-just');
      var x = box.querySelector('.lu-cup__fx');
      if (x && x.parentNode) x.parentNode.removeChild(x);
    }, 1100);
  }

  /* Toque en REDIMIR. Delegado en document: sobrevive los re-renders del cajon.
     Si el celular no deja guardar (modo privado), el cerebro no otorga y aqui no
     se promete nada: la tira queda como estaba. */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-lu-cup-go]') : null;
    if (!b) return;
    e.preventDefault();
    if (b.getAttribute('aria-disabled') === 'true' || estado()) return;
    var c = window.luCoupon, q = quedate();
    if (!c || !q || yaCompro()) return;
    try {
      if (!q.granted) c.grantQuedate(true);
      else if (q.rescueAvailable) c.grantRescue(true);
    } catch (err) {}
    if (!estado()) return;
    festeja(b);
    pinta();
    try { document.dispatchEvent(new CustomEvent('lu:cupon-cambio')); } catch (e2) {}
    /* marca para Clarity: permite filtrar las grabaciones de quien redimio en el carrito */
    try { if (typeof window.clarity === 'function') window.clarity('event', 'cupon_carrito_redimido'); } catch (e3) {}
  });

  window.luCupPinta = pinta;
  /* este archivo llega cuando llega (async): si el cajon ya pinto, se pone al dia */
  try { pinta(); } catch (e) {}
})();
